import {
  BROWSE_PLACEMENTS,
  PLACEMENT_MODIFIER_MAX,
  PLACEMENT_MODIFIER_MIN,
  PLACEMENT_ROW_ORDER,
} from "../../constants/placements.constants"
import { IPlacementDataTable } from "../../types/placement"
import { placementsEnum } from "../../types/types"

const UNKNOWN_PLACEMENT_ORDER = PLACEMENT_ROW_ORDER.length

const orderIndex = (placement: string): number => {
  const index = PLACEMENT_ROW_ORDER.indexOf(placement as placementsEnum)
  return index === -1 ? UNKNOWN_PLACEMENT_ORDER : index
}

export const sortPlacementRows = (rows: IPlacementDataTable[]): IPlacementDataTable[] =>
  [...rows].sort((left, right) => orderIndex(left.placement) - orderIndex(right.placement))

export const isBrowsePlacement = (placement: string | undefined): boolean =>
  BROWSE_PLACEMENTS.includes(placement as placementsEnum)

export const clampPlacementModifier = (value: number): number => {
  if (!Number.isFinite(value)) {
    return PLACEMENT_MODIFIER_MIN
  }

  const bounded = Math.min(Math.max(value, PLACEMENT_MODIFIER_MIN), PLACEMENT_MODIFIER_MAX)
  return Number(bounded.toFixed(2))
}
